import { Injectable } from '@angular/core'
import { Cart, CART_NORMALIZER } from '@spartacus/cart/base/root'
import { OccCheckoutPaymentTypeAdapter } from '@spartacus/checkout/b2b/occ'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class EbPaymentTypeAdapter extends OccCheckoutPaymentTypeAdapter {
  public setPaymentType(
    userId: string,
    cartId: string,
    paymentType: string,
    purchaseOrderNumber?: string
  ): Observable<Cart> {
    return this.http
      .put(this.getSetCartPaymentTypeEndpoint(userId, cartId, paymentType, purchaseOrderNumber), {})
      .pipe(this.converter.pipeable(CART_NORMALIZER))
  }

  protected getSetCartPaymentTypeEndpoint(
    userId: string,
    cartId: string,
    paymentType: string,
    purchaseOrderNumber?: string
  ): string {
    const queryParams = purchaseOrderNumber ? { paymentType, purchaseOrderNumber } : { paymentType }
    return this.occEndpoints.buildUrl('setCartPaymentType', {
      urlParams: { userId, cartId },
      queryParams
    })
  }
}
